import MetadataManager from './common/MetadataManager';
import GroupAgentAvatars from './group/GroupAgentAvatars';
import { UsersIcon } from '@heroicons/react/24/outline';
import ManageAgentsModal from './group/ManageAgentsModal';
import { useState } from 'react';
import { Group } from '../../services/groupService';
import { useTheme } from '../../contexts/ThemeContext';
import { t } from 'i18next';

export default function GroupManagement() {
  const [isManageAgentsModalOpen, setIsManageAgentsModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<Group | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);
  const { theme } = useTheme();

  const refreshData = () => {
    setSelectedGroup((prev) => ({ ...prev! }));
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleManageAgents = (group: Group) => {
    setSelectedGroup(group);
    setIsManageAgentsModalOpen(true);
  };

  const renderExtraActions = (item: Group) => (
    <button
      onClick={() => handleManageAgents(item)}
      className={`mr-4 ${
        theme === 'dark'
          ? 'text-indigo-400 hover:text-indigo-300'
          : 'text-indigo-600 hover:text-indigo-900'
      }`}
      title="Manage Agents"
    >
      <UsersIcon className="h-5 w-5" />
    </button>
  );

  const renderExtraColumns = (item: Group) => (
    <td
      className={`px-6 py-4 whitespace-nowrap text-sm ${
        theme === 'dark' ? 'text-gray-300' : 'text-gray-500'
      }`}
    >
      <GroupAgentAvatars groupId={item.id} />
    </td>
  );

  return (
    <>
      <MetadataManager
        key={refreshTrigger}
        title={t('settings.groupManagement.title')}
        type="groups"
        description={t('settings.groupManagement.description')}
        renderExtraActions={renderExtraActions}
        renderExtraColumns={renderExtraColumns}
        extraColumnHeaders={[
          {
            label: 'Agents',
            className: `px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${
              theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
            }`
          }
        ]}
      />

      {isManageAgentsModalOpen && selectedGroup && (
        <ManageAgentsModal
          group={selectedGroup}
          refreshData={refreshData}
          onClose={() => {
            setIsManageAgentsModalOpen(false);
            setSelectedGroup(null);
            refreshData();
          }}
        />
      )}
    </>
  );
}
